import React, { useContext, useState } from 'react'
import 'src/App.css'
import { Homepage } from '../HomePage/Homepage'
import { Sidebar } from 'src/components/Global/SideBar/Sidebar'
import { SideProfile } from 'src/components/Global/SideBar/SideProfile'
import { Settings } from '../Settings'
import { FaqPage } from '../Faq'
import { Collabo } from '../Collabo'
import { Investment } from '../Investment'
import { SavingsPage } from '../Savings'
import { GeneralSavingsPage } from '../GeneralSavings'
import { TargetSavings } from '../TargetSavings'
import { EmergencySavings } from '../EmergencySavings'
import { MoreTransaction } from 'src/components/HomePage/ModalsContent/Transaction/Transactions/MoreTransaction'
import { SecurePasswordPage } from 'src/Pages/Auth/Register/Secure'
import {
  Modal,
  CustomModal,
  PlanCustomModal,
  CollaboCustomModal,
  PlansModal,
  CardCustomModal,
  BankCustomModal,
  InvestmentCustomModal,
  PlanTargetCustomModal,
  PaymentPlanCustomModal,
  PaymentPlanTargetCustomModal,
  PaymentHomePageCustomModal,
  HelpModal,
  EarnModal,
  ContestModal,
  ContestDetailModal,
  ContestPaymentModal,
  ContestJoinedModal,
  JoinedLeaderboardModal,
  JoinedActivityModal,
  JoinedAboutModal,
  ContestXPaymentModal,
} from 'src/components/Global/Modal/Modal'
import styled, { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme } from '../../theme'

import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import ProtectedRoutes from 'src/components/protectedRoute/ProtectedRoute'
import InnerContent from 'src/components/protectedRoute/innerContent'
import AlertMessage from 'src/components/Global/Alert/AlertMessage'
import { SnackbarContext } from 'src/contexts/Snack'
import { SnackbarActionTypes } from 'src/contexts/Snack/types'
import IdleTimerContainer from '../IdleTimer/IdleTimerContainer'
import Xcontest from 'src/components/Xcontest/Xcontest'

import { RegisterPage } from 'src/Pages/Auth/Register'
import { Login } from 'src/Pages/Auth/Login'
import { ForgotPasswordPage } from 'src/Pages/Auth/Forgot-password'
const StyledApp = styled.div`
  background: ${(props) => props.theme.colors.body};

  .App {
    background: ${(props) => props.theme.colors.body};
  }
  .sidenav,
  .dashboardComponent {
    background: ${(props) => props.theme.colors.body};
    height: auto;
    /* background: red; */
  }
`
const themes: any = {
  light: lightTheme,
  dark: darkTheme,
}
const checkVerification = () => {
  if (window.location.href.indexOf('account') > -1) {
    return false
  } else {
    return true
  }
}
const Dashboard = () => {
  const homepage = checkVerification()
  const [theme, setTheme] = useState('light')
  let location = useLocation()
  let state = location.state as { backgroundLocation?: Location }

  const snackbar: any = useContext(SnackbarContext)
  const { state: snackbarState, dispatch: snackbarDispatch } = snackbar

  const onHideSnackbar = () =>
    snackbarDispatch({ type: SnackbarActionTypes.CLOSE_SNACKBAR })

  // console.log('\n\n\n\nsnackbarState', snackbarState)

  return (
    <>
      <ThemeProvider theme={themes[theme]}>
        <AlertMessage {...snackbarState} onClose={onHideSnackbar} />
        <StyledApp>
          <Routes>
            <Route path="/accounts/login" element={<Login />} />
            <Route path="/accounts/register" element={<RegisterPage />} />
            <Route
              path="/accounts/forgot-password"
              element={<ForgotPasswordPage />}
            />
            <Route
              path="/accounts/secure-password"
              element={<SecurePasswordPage />}
            />
          </Routes>
          {homepage && (
            <div className="App">
              <div className="nav">
                <Sidebar />
              </div>
              <div className="sidenav">
                <div className="sideProfile">
                  <SideProfile theme={theme} setTheme={setTheme} />
                </div>
                <div className="dashboardComponent">
                  <Routes>
                    <Route path="/" element={<ProtectedRoutes />}>
                      <Route path="/" element={<InnerContent />}>
                        <Route
                          path="/"
                          element={<Navigate replace to="homepage" />}
                        />
                        <Route path="homepage" element={<Homepage />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/faqs" element={<FaqPage />} />
                        <Route path="/collabo" element={<Collabo />} />
                        <Route path="/x-contest" element={<Xcontest />} />
                        <Route
                          path="/transactions"
                          element={<MoreTransaction />}
                        />
                        <Route path="/invest" element={<Investment />} />
                        <Route path="/savings" element={<SavingsPage />} />
                        <Route
                          path="/general-savings"
                          element={<GeneralSavingsPage />}
                        />
                        <Route
                          path="/target-savings"
                          element={<TargetSavings />}
                        />
                        <Route
                          path="/emergency-savings"
                          element={<EmergencySavings />}
                        />
                      </Route>
                    </Route>
                  </Routes>
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<Modal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<HelpModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<EarnModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<CustomModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/plan-detail/:id"
                        element={<PlanCustomModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/joined-contest/activity/:id"
                        element={<JoinedActivityModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<PaymentPlanCustomModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/xcontest/contest-detail/:id"
                        element={<ContestModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<ContestPaymentModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<ContestDetailModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/joined-contest/:id"
                        element={<ContestJoinedModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/joined-contest/leaderboard/:id"
                        element={<JoinedLeaderboardModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/joined-contest/about/:id"
                        element={<JoinedAboutModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/:id"
                        element={<PaymentPlanTargetCustomModal />}
                      />
                    </Routes>
                  )}

                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/:id" element={<ContestXPaymentModal />} />
                    </Routes>
                  )}

                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/:id"
                        element={<PaymentHomePageCustomModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/target-detail/:id"
                        element={<PlanTargetCustomModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/acceptCollabo/:id"
                        element={<CollaboCustomModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route
                        path="/invest-information/:id"
                        element={<InvestmentCustomModal />}
                      />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="/bank/:id" element={<BankCustomModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="plan/:id" element={<PlansModal />} />
                    </Routes>
                  )}
                  {state?.backgroundLocation && (
                    <Routes>
                      <Route path="card/:id" element={<CardCustomModal />} />
                    </Routes>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* </IdleTimerContainer> */}
        </StyledApp>
      </ThemeProvider>
    </>
  )
}

export { Dashboard }
